import type { ServiceTicketCreateSchemaType } from './schema';

type AssigneeFields = Pick<
  ServiceTicketCreateSchemaType,
  'assignment_type' | 'assigned_to' | 'ops_service_id'
>;

export type AssigneePayload = { technician_id?: number; ops_service_id?: string };

/**
 * Only the assignee for the selected type is sent: ops_service_id for External, technician_id for
 * Internal. Boro rejects a request that carries an ops service together with a technician > 0.
 * Returns an empty object when nothing is selected for the chosen type.
 */
export const getAssigneePayload = (data: AssigneeFields): AssigneePayload => {
  if (data.assignment_type === 'external') {
    return data.ops_service_id ? { ops_service_id: data.ops_service_id } : {};
  }
  return data.assigned_to ? { technician_id: Number.parseInt(data.assigned_to, 10) } : {};
};
